import { GetIntegrationResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { QueryOptions } from "../../types/react-query";
import { api } from "../api";
import { integrationKeys } from "../queryKeys";

export const getIntegrations =
  async (): Promise<GetIntegrationResponseBodyType> => {
    const resp =
      await api.get<GetIntegrationResponseBodyType>(`/v2/integrations`);
    return resp.data;
  };

export const useGetIntegrations = (
  enabled?: boolean,
  options?: QueryOptions<GetIntegrationResponseBodyType, Error>
) => {
  return useQuery<GetIntegrationResponseBodyType, Error>({
    ...options,
    queryKey: integrationKeys.all,
    queryFn: async () => getIntegrations(),
    enabled: enabled === undefined ? true : enabled,
  });
};
